// Escapa texto que vai para HTML injetado (popups/tooltips do Leaflet).
// POR QUE ISSO EXISTE: o `bindTooltip`/`bindPopup` do Leaflet insere string como **HTML** (innerHTML).
// Nomes de cliente/vendedor vêm do ERP e de formulários — são dados NÃO confiáveis. Sem escapar, um
// cliente cadastrado como `<img src=x onerror=...>` executa script na sessão do gestor (XSS armazenado).
// Escapa também aspas para ser seguro em posição de atributo, não só de texto.
export function escHtml(s: any): string {
  return String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
